import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useIsGolfFacility_facility$key } from "./__generated__/useIsGolfFacility_facility.graphql";

export const useIsGolfFacility = (
  facilityRef: useIsGolfFacility_facility$key | null
) => {
  const facility = useFragment(useIsGolfFacilityFragmentString, facilityRef);
  return facility?.type === "GOLF_COURSE";
};

const useIsGolfFacilityFragmentString = graphql`
  fragment useIsGolfFacility_facility on Facility {
    type
  }
`;
